import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { RouteType } from "../models/enum";
import { ProfileService } from "../shared/services/profile.service";
import { SharedService } from "../shared/services/shared.service";

@Component({
	selector: "app-cbta-web",
	templateUrl: "./cbta-web.component.html",
	styleUrls: ["./cbta-web.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CbtaWebComponent implements OnInit {
	expanded: boolean = false;
	isOnline: boolean = true;

	constructor(
		private sharedService: SharedService,
		private profileService: ProfileService,
		private router: Router,
		private cdr: ChangeDetectorRef,
	) {}

	ngOnInit(): void {
		this.sharedService.getSideBarExpanded().subscribe((expanded: boolean) => {
			this.expanded = expanded;
		});

		this.sharedService.getIsStatusOnline().subscribe((status: boolean) => {
			this.isOnline = status;
			this.cdr.detectChanges();
		});

		if (navigator.onLine) {
			this.profileService.initUser();
		}
	}

	get showProfileSetup(): boolean {
		const hasProfile = this.profileService.hasProfile;
		const currentRoute = this.router.url;

		return !hasProfile && currentRoute !== "/profile";
	}

	goToProfile(): void {
		this.router.navigate([RouteType.PROFILE]);
	}
}
